import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
export function Footer() {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  return <>
      <footer className="bg-black text-white py-12 border-t border-yellow-500/30" data-id="element-70">
        <div className="max-w-6xl mx-auto px-6" data-id="element-71">
          <div className="flex flex-col items-center gap-8" data-id="element-72">
            {/* Signature */}
            <div className="flex flex-col items-center gap-4" data-id="element-73">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ffEqoc8aS1PC8Coiz1CKY3/gb_signature.png" alt="Gabriel Beltran Signature" className="h-12 sm:h-16 w-auto object-contain opacity-90" data-id="element-74" />
              <p className="text-gray-400 text-sm" data-id="element-75">Gabriel Beltrán</p>
            </div>

            {/* Links */}
            <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8 text-sm" data-id="element-76">
              <button onClick={() => setIsPrivacyModalOpen(true)} className="text-gray-300 hover:text-yellow-400 transition-colors font-medium" data-id="element-77">
                Política de Privacidad
              </button>
              <span className="hidden sm:inline text-gray-600" data-id="element-78">|</span>
              <a href="mailto:support@truemarketer.com" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium" data-id="element-79">
                support@truemarketer.com
              </a>
            </div>

            {/* Copyright */}
            <div className="text-center text-gray-500 text-sm" data-id="element-80">
              <p data-id="element-81">
                © {new Date().getFullYear()} InfoCommerce AI Bootcamp. Todos
                los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>

      <PrivacyPolicyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} data-id="element-82" />
    </>;
}